import { render, staticRenderFns } from "./card-briefing-selected-professional.vue?vue&type=template&id=18e569ce&"
import script from "./card-briefing-selected-professional.vue?vue&type=script&lang=js&"
export * from "./card-briefing-selected-professional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports